import { mutations } from "@/graphql";
import { useMutation } from "@apollo/client/react";
import { useCallback } from "react";
import type { MutationAddCustomerUserArgs } from "@/types/graphql";
/**
 * Custom hook to add a user to a company.
 * @param {Function} [onCompleted] - Callback function to be called when the mutation completes successfully.
 * @param {Function} [onError] - Callback function to be called when an error occurs during the mutation.
 * @returns {{addCustomer: Function, loading: boolean}} - The function to add a customer and the loading state.
 */
export function useAddUserCompany(
  onCompleted: (data?: any) => void = () => {},
  onError: (error?: any) => void = () => {},
) {
  const [comAddCustomerUser, { loading }] = useMutation<any>(
    mutations.addCustomerUser,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: ["getUserCustomers"],
    },
  );

  const addCustomer = useCallback(
    (variables: MutationAddCustomerUserArgs) => {
      comAddCustomerUser({
        variables,
      });
    },
    [comAddCustomerUser],
  );

  return {
    addCustomer,
    loading,
  };
}
